const metaAuthApiUrl = "https://www.facebook.com/v21.0/dialog/oauth";

const metaSettings = {
  dev: {
    metaAuthApiUrl,
    client_id: 1454221183106294,
    redirect_uri: "http://localhost:3000/callbacks/meta",
    scope: "instagram_basic,instagram_content_publish,pages_show_list,pages_read_engagement,business_management,pages_manage_posts",
    response_type: "code",
    // Re-prompts for permissions the user previously declined. Does NOT force Meta to
    // re-show page selection for already-granted permissions — that still requires
    // editing the app under Facebook > Settings > Apps and Websites.
    auth_type: "rerequest",
  },
  stage: {
    metaAuthApiUrl,
    client_id: 1454221183106294,
    redirect_uri: "https://stage.mymediaplanner.com/callbacks/meta",
    scope: "instagram_basic,instagram_content_publish,pages_show_list,pages_read_engagement,business_management,pages_manage_posts",
    response_type: "code",
    // Re-prompts for permissions the user previously declined. Does NOT force Meta to
    // re-show page selection for already-granted permissions — that still requires
    // editing the app under Facebook > Settings > Apps and Websites.
    auth_type: "rerequest",
  },
  prod: {
    metaAuthApiUrl,
    client_id: 1454221183106294,
    redirect_uri: "https://mymediaplanner.com/callbacks/meta",
    scope: "instagram_basic,instagram_content_publish,pages_show_list,pages_read_engagement,business_management,pages_manage_posts",
    response_type: "code",
    // Re-prompts for permissions the user previously declined. Does NOT force Meta to
    // re-show page selection for already-granted permissions — that still requires
    // editing the app under Facebook > Settings > Apps and Websites.
    auth_type: "rerequest",
  },
};

const getMetaSettings = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "stage":
      return metaSettings.stage;
    case "prod":
      return metaSettings.prod;
    default:
      return metaSettings.dev;
  }
};

export default getMetaSettings;
